import { render, staticRenderFns } from "./PlansIndex.vue?vue&type=template&id=6f72e881"
import script from "./PlansIndex.vue?vue&type=script&lang=js"
export * from "./PlansIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f72e881')) {
      api.createRecord('6f72e881', component.options)
    } else {
      api.reload('6f72e881', component.options)
    }
    module.hot.accept("./PlansIndex.vue?vue&type=template&id=6f72e881", function () {
      api.rerender('6f72e881', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/fees/PlansIndex.vue"
export default component.exports